import type { SVGProps } from 'react';

type LibIconSVGProps = SVGProps<SVGSVGElement> & {
  fill?: string;
  isPdf?: boolean;
};

export function HourglassTopOutlined({ fill = '#222', isPdf = false, ...props }: LibIconSVGProps) {
  if (isPdf) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" {...props}>
        <path
          d="M2.5 0.833374L2.50417 3.33337L4.16667 5.00004L2.50417 6.67087L2.5 9.16671H7.5V6.66671L5.83333 5.00004L7.5 3.33754V0.833374H2.5ZM6.66667 6.87504V8.33337H3.33333V6.87504L5 5.20837L6.66667 6.87504Z"
          fill="#EF6C00"
        />
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path fill={fill} d="m6 2 .01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2zm10 14.5V20H8v-3.5l4-4z"></path>
    </svg>
  );
}

export default HourglassTopOutlined;
